import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import i18n from 'i18n-react';

const FreeHotel = (props) => {
  const {
    id,
    bgImage,
    flyToMarker,
    hotelInfo,
    hotelName,
    location,
    phoneNumber,
    address,
    category,
    other,
    item,
  } = props;
  return (
    <div
      className="freeDiv"
      id={id}
    >
      <div className="iconDiv">
        <span
          className="fa-layers fa-fw fa-2x markerCircle"
          onClick={flyToMarker}
          key="map"
        >
          <FontAwesomeIcon icon={['fas', 'circle']} className="circle" />
          <FontAwesomeIcon
            icon={['fas', 'map-marker-alt']}
            className="marker"
          />
        </span>
      </div>
      <div className="freeInfoDiv" onClick={hotelInfo}>
        <img src={bgImage} className="image" loading="lazy" onError={e => e.target.style.display = 'none'} alt="" />
        <div className="content">
          <span className="freeHotelName">{hotelName}</span> <br />
          <br />
          <span className="freeHotelAddr">
           {item.addr1}
          </span>{' '}
          <br />
          <span className="freeHotelCategory">
          {i18n.translate(`directory.${item.category.replace(/\s/g, '').replace(/&/g, '').replace(/,/g, '').replace(/&/g, '').replace(/,/g, '').replace(/-/g, '').replace('+', '').replace(/:/g, '').toLowerCase()}`)}                    
          </span> <br />
          <span className="freeHotelPhone">{item.phone}</span> <br />
          <span className="freeHotelPhone">{item.email}</span> <br />
          <br />
          <span className="moreInfo">{i18n.translate('directoryView.viewNow')}</span>
          <br />
          <br />
        </div>
      </div>
    </div>
  );
};

FreeHotel.propTypes = {
  id: PropTypes.string,
  bgImage: PropTypes.string,
  propertyName: PropTypes.string,
  flyToMarker: PropTypes.func,
  hotelInfo: PropTypes.func,
  hotelName: PropTypes.string,
  location: PropTypes.string,
  phoneNumber: PropTypes.string,
  address: PropTypes.string,
  category: PropTypes.string,
  other: PropTypes.array,
};

FreeHotel.defaultProps = {
  id: '',
  bgImage: '',
  propertyName: '',
  flyToMarker: () => {},
  hotelInfo: () => {},
  hotelName: '',
  location: '',
  phoneNumber: '',
  address: '',
  category: '',
  other: [],
};

export default FreeHotel;
